import { Modal, Stack, Text, Textarea, Group, Button } from "@mantine/core";
import { useState } from "react";

interface RejectCompanyModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
  companyName?: string;
  title?: string;
  description?: string;
  confirmLabel?: string;
}

export default function RejectCompanyModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
  companyName,
  title = "Disable Company Profile",
  description,
  confirmLabel = "Disable Profile",
}: RejectCompanyModalProps) {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const bodyText = description ?? (companyName
    ? `You are about to disable the profile for "${companyName}". The company will no longer be discoverable or able to use platform features. Active collaborations will continue. Please provide a reason.`
    : "Please provide a reason for disabling this company profile. This will be shared with the company.");

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={
        <Text fw={600} size="lg">
          {title}
        </Text>
      }
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm" c="slate.6">
          {bodyText}
        </Text>

        <Textarea
          label="Reason"
          placeholder="Add your reasons here."
          minRows={4}
          maxRows={6}
          value={reason}
          onChange={(e) => setReason(e.currentTarget.value)}
          required
        />

        <Group justify="flex-end" mt="md">
          <Button color="primary.6" onClick={handleConfirm} loading={isLoading} disabled={!reason.trim()}>
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
